import { fontSize } from '@noths/polaris-client-ribbons-base';
import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from 'src/styles/dontgiftguide.styles';

const { spacing, text, fonts } = dggTheme;

export const LIGHT_COLOR = 'var(--dgg-neutral-white)';
export const DARK_COLOR = 'var(--dgg-paris-m)';

export const title = css`
  position: relative;
  text-align: center;
  padding: ${pxToRem(spacing.sm)} 0;
  margin: 0;
  ${fontSize(text.HEADING.XS)}
  font-family: ${fonts.PRIMARY_SEMIBOLD.familyWithFallbacks};
  font-weight: ${fonts.PRIMARY_SEMIBOLD.weight};

  ${mediaQuery(
    { min: breakpoint },
    css`
      ${fontSize(text.HEADING.XL)}
    `,
  )}
`;

export const titleLight = css`
  color: ${LIGHT_COLOR};
`;

export const titleDark = css`
  color: ${DARK_COLOR};
`;

export const icon = css`
  position: absolute;
  top: ${pxToRem(20)};
  right: ${pxToRem(16)};
  width: ${pxToRem(16)};
  height: ${pxToRem(16)};
`;

export const summary = css`
  outline: none;
  cursor: pointer;

  /* Hides marker on Chrome */
  list-style: none;

  /* Hides marker on Safari */
  &::-webkit-details-marker {
    display: none;
  }
`;
